import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { cn } from '@lib/utils';

function Checkbox({
  className,
  label,
  disabled,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & { label?: string }) {
  return (
    <div
      className={cn('flex items-center gap-x-2', disabled ? 'opacity-50' : '')}
    >
      <CheckboxPrimitive.Root
        className={cn(
          'h-[14px] w-[15px] border-2 border-white rounded-[2px] peer data-[state=checked]:bg-secondary data-[state=checked]:text-primary-foreground data-[state=checked]:border-secondary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 shadow-xs transition-shadow outline-none focus-visible:ring-[3px]',
          className,
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
        data-slot="checkbox"
        disabled={disabled}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className="flex items-center justify-center text-current transition-none"
          data-slot="checkbox-indicator"
        >
          <CheckIcon className="size-3.5" color="black" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && <p className={'text-xs'}>{label}</p>}
    </div>
  );
}

export { Checkbox };
